import { render, staticRenderFns } from "./BoardOfDirectors.vue?vue&type=template&id=18207c16&"
import script from "./BoardOfDirectors.vue?vue&type=script&lang=js&"
export * from "./BoardOfDirectors.vue?vue&type=script&lang=js&"
import style0 from "./BoardOfDirectors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports